import { Injectable } from '@angular/core';
import { BaseHelpService } from '../../services';


/**
* This service handles view help modal.
*/
@Injectable({ providedIn: 'root' })
export class ViewHelpService extends BaseHelpService {

	override get fileKey(): string {
		return 'VIEW_CASE';
	}

}
